import { Injectable } from "@angular/core";
import { log } from '../utils/logging';
import { FaceLoginRequest, FaceLoginResponse } from "../interfaces/facelogin";
import { LogUpload } from "../utils/log-upload";
import { AppConfig } from "./app.config.services";
import { TranslocoService } from "@ngneat/transloco";
import { ToastrService } from "ngx-toastr";

@Injectable()
export class FaceLoginService {
    logUploader: LogUpload = new LogUpload("FaceLoginService");

    isFaceAuthSuccess: boolean = false;

    faceLoginErrorMessage: string = "";
    faceLoginSuccessMessage: string = "";

    faceLoginErrorMessage1: string = "";
    faceLoginErrorMessage2: string = "";
    faceLoginErrorMessage3: string = "";
    faceLoginErrorMessage4: string = "";
    faceLoginErrorMessage5: string = "";
    faceLoginErrorMessage6: string = "";
    faceLoginErrorMessage7: string = "";
    faceLoginErrorMessage8: string = "";
    faceLoginErrorMessage9: string = "";
    faceLoginErrorMessage10: string = "";
    faceLoginErrorMessage11: string = "";

    private faceAuthRequest: FaceLoginRequest = {
        lanId: "",
        snapdata: "",
        originator: "SWFHSupervisor",
        faceauthconfidence: 0,
    }

    constructor(private toastService: ToastrService, private translationService: TranslocoService) {
        this.UpdateComponentLabels();
    }

    ngOnInit = (): void => {
        this.UpdateComponentLabels();
    }

    setFaceAuthRequestInitialParams = (lanId: string, snapdata: string): boolean => {
        if (lanId != null && lanId != "" && snapdata != null && snapdata != "") {
            this.faceAuthRequest.lanId = lanId;
            this.faceAuthRequest.snapdata = snapdata;
            return true;
        }
        else return false;
    }

    setFaceAuthRequestConfidence = (confidence: number): boolean => {
        if (confidence != null && confidence != 0) {
            this.faceAuthRequest.faceauthconfidence = confidence / 100;
            return true;
        }
        else return false;
    }

    AuthenticateUser = async (): Promise<boolean> => {
        const baseURL: string | null = AppConfig.GetServerBaseURL();
        if (baseURL != null && baseURL != '') {
            const headers: Headers = new Headers();
            headers.append("Content-Type", "application/json");
            const selectedURL: string = `${baseURL}api/v1/authenticate`;

            try {
                const apiResponse: Response = await fetch(selectedURL, { method: 'POST', headers, body: JSON.stringify(this.faceAuthRequest) });

                if (apiResponse.ok === true) {
                    const resp: FaceLoginResponse = await apiResponse.json();

                    if (resp != null) {
                        if (resp.errorCode != null || resp.errorMessage != null) {
                            log.error(`An error occurred while authenticating the user (facelogin): \nError Code: ${resp.errorCode}\nError Message: ${resp.errorMessage}`, null);
                            this.logUploader.error("AuthenticateUser", `An error occurred while authenticating the user (facelogin): \nError Code: ${resp.errorCode}\nError Message: ${resp.errorMessage}`, null);

                            switch (resp.errorCode) {
                                case "FailedToCalCosineDist":
                                    this.toastService.error(`${this.faceLoginErrorMessage} - ${this.faceLoginErrorMessage1}`);
                                    break;
                                case "FaceNotFound":
                                case "FailedToDetectFace":
                                    this.toastService.error(`${this.faceLoginErrorMessage} - ${this.faceLoginErrorMessage2}`);
                                    break;
                                case "FailedToLoadImage":
                                    this.toastService.error(`${this.faceLoginErrorMessage} - ${this.faceLoginErrorMessage3}`);
                                    break;
                                case "InvalidRequest":
                                    this.toastService.error(`${this.faceLoginErrorMessage} - ${this.faceLoginErrorMessage4}`);
                                    break;
                                case "FailedToConnectRedis":
                                    this.toastService.error(`${this.faceLoginErrorMessage} - ${this.faceLoginErrorMessage5}`);
                                    break;
                                case "Invalid user":
                                case "EncodingNotFoundInRedis":
                                    this.toastService.error(`${this.faceLoginErrorMessage} - ${this.faceLoginErrorMessage7}`);
                                    break;
                                case "SQLOperationNotFound":
                                    this.toastService.error(`${this.faceLoginErrorMessage} - ${this.faceLoginErrorMessage6}`);
                                    break;
                                default:
                                    this.toastService.error(`${this.faceLoginErrorMessage} \n${resp.errorCode}`);
                                    break;
                            }

                            return false;
                        }
                        else if (resp.isVerfied === false) {
                            log.error(`An error occurred while authenticating the user (facelogin): cosine distance is ${resp.cosineDistance}`, null);
                            this.logUploader.error("AuthenticateUser", `An error occurred while authenticating the user (facelogin): cosine distance is ${resp.cosineDistance}`, null);

                            if (resp.cosineDistance != null && resp.cosineDistance !== "") {
                                const distance: number = Number(resp.cosineDistance);

                                if (distance > 0.6)
                                    this.toastService.error(`${this.faceLoginErrorMessage9} - ${this.faceLoginErrorMessage7}`);
                                // else if (distance >= 0.5 && distance <= 0.6)
                                //     this.toastService.error(`Login Failed - Face not detected. Please ensure your face is clearly visible and not covered.`);
                                else this.toastService.error(`${this.faceLoginErrorMessage9} - ${this.faceLoginErrorMessage2}`);
                            }
                            else this.toastService.error(`${this.faceLoginErrorMessage9} - ${this.faceLoginErrorMessage2}`);
                            return false;
                        }
                        else {
                            log.info(`Supervisor FaceLogin authenticated successfully with cosine distance ${resp.cosineDistance}`);
                            this.logUploader.info("AuthenticateUser", `Supervisor FaceLogin authenticated successfully with cosine distance ${resp.cosineDistance}`);
                            this.toastService.success(this.faceLoginSuccessMessage);
                            this.isFaceAuthSuccess = true;
                            return true;
                        }
                    }
                    else {
                        log.error(`An error occurred while authenticating the user (facelogin): response is null`, null);
                        this.logUploader.error("AuthenticateUser", `An error occurred while authenticating the user (facelogin): response is null`, null);
                        this.toastService.error(`${this.faceLoginErrorMessage} - ${this.faceLoginErrorMessage10}`);
                        return false;
                    }
                }
                else {
                    log.error(`An error occurred while authenticating the user (facelogin): ${apiResponse.statusText}`, null, apiResponse);
                    this.logUploader.error("AuthenticateUser", `An error occurred while authenticating the user (facelogin): ${apiResponse.statusText}`, null);
                    this.toastService.error(`${this.faceLoginErrorMessage} - ${this.faceLoginErrorMessage11}`);
                    return false;
                }
            } catch (error: any) {
                log.error(`Error in AuthenticateUser`, error);
                return false;
            }
        }
        else {
            log.error(`TRSServerURL is not configured`, null);
            return false;
        }
    }

    UpdateComponentLabels = (): void => {
        this.faceLoginErrorMessage = this.translationService.translate("An error occurred while authenticating the user");
        this.faceLoginSuccessMessage = this.translationService.translate("Face Login Successful");
        this.faceLoginErrorMessage1 = this.translationService.translate("Unable to do facial matching. Make sure your face is well-lit and unobstructed.");
        this.faceLoginErrorMessage2 = this.translationService.translate("Face not detected. Please ensure your face is clearly visible and not covered.");
        this.faceLoginErrorMessage3 = this.translationService.translate("Internal Server error (image). Please contact Admin.");
        this.faceLoginErrorMessage4 = this.translationService.translate("Internal Server error (request). Please contact Admin.");
        this.faceLoginErrorMessage5 = this.translationService.translate("Internal Server error (redis). Please contact Admin.");
        this.faceLoginErrorMessage6 = this.translationService.translate("Internal Server error (SQL). Please contact Admin.");
        this.faceLoginErrorMessage7 = this.translationService.translate("User configuration error in OCM. Please contact Admin.");
        this.faceLoginErrorMessage8 = this.translationService.translate("Invalid Supervisor LanId used.");
        this.faceLoginErrorMessage9 = this.translationService.translate("Login Failed");
        this.faceLoginErrorMessage10 = this.translationService.translate("Received empty response from FaceAuth server");
        this.faceLoginErrorMessage11 = this.translationService.translate("Received failure response from FaceAuth server");
    }
}